<div class="custom-sort-header-container" fxLayout="row"
     [class.custom-sort-header-sorted]="_isSorted()"
     [class.custom-sort-header-position-before]="arrowPosition == 'before'">
    <div class="custom-sort-header-button"
            [attr.disabled]="_isDisabled() || null"
            [attr.aria-label]="sortButtonLabel(id)"
            (focus)="_setIndicatorHintVisible(true)"
            (blur)="_setIndicatorHintVisible(false)">
        <span><ng-content></ng-content></span>
    </div>
    <!-- Отключить анимацию во время работы текущей анимации -->
    <div class="custom-sort-header-arrow"
         [@arrowOpacity]="_getArrowViewState()"
         [@arrowPosition]="_getArrowViewState()"
         [@allowChildren]="_getArrowDirectionState()"
         (@arrowPosition.start)="_disableViewStateAnimation = true"
         (@arrowPosition.done)="_disableViewStateAnimation = false">
        <div class="custom-sort-header-stem"></div>
        <div class="custom-sort-header-indicator" [@indicator]="_getArrowDirectionState()">
            <div class="custom-sort-header-pointer-left" [@leftPointer]="_getArrowDirectionState()"></div>
            <div class="custom-sort-header-pointer-right" [@rightPointer]="_getArrowDirectionState()"></div>
            <div class="custom-sort-header-pointer-middle"></div>
        </div>
    </div>
</div>
